import { isArrayWithItems as f } from "./array-helper.js";
const u = (e, r, t) => {
  const s = [];
  if (!e)
    return s;
  for (const [c, o] of Object.entries(e)) {
    const n = r[c];
    o?.message && typeof o?.message == "string" ? s.push({
      text: `${n}: ${o.message}`
    }) : o?.type === "required" && s.push({
      text: `${n}: ${t("INPUT_FIELD_REQUIRED")}`
    });
  }
  return s;
}, m = (e) => {
  const r = [];
  if (!e.errorObject || !e.errorObject.errors)
    return r;
  for (const t of Object.values(e.errorObject.errors))
    f(t) && typeof t[0] == "string" && r.push({
      text: t[0]
    });
  return r;
};
export {
  m as getErrorsFromApiError,
  u as getErrorsFromHookFormError
};
